import type { KYCLevel, KYCStatus, User, UserInformation } from '../../@types/user';

const BLANK_INFORMATION: UserInformation = {
    firstName: '',
    lastName: '',
    address: '',
    province: '',
    zipCode: '',
};

const UNVERIFIED_KYC = {
    level: 'l0' as KYCLevel,
    status: 'confirmed' as KYCStatus,
};

export function normalizeAuthUser(user: User): User;
export function normalizeAuthUser(user: User | undefined): User | undefined;
export function normalizeAuthUser(user: User | undefined): User | undefined {
    if (!user) return user;

    return {
        ...user,
        email: user.email ?? '',
        kyc: user.kyc ?? UNVERIFIED_KYC,
        information: user.information ?? BLANK_INFORMATION,
    };
}
